/**
 * Splits a getAddress.io line ("line1, line2, line3, line4, locality, town, county")
 * into the fields the admin Add Patient form uses. Blank parts keep their position,
 * which is why this can't reuse the already-joined strings from getAddressesByPostcode.
 */
export function parseAddressLine(raw) {
  const parts = String(raw || '').split(',').map((p) => p.trim());
  if (parts.length >= 7) {
    const [line1, l2, l3, l4, locality, town, county] = parts;
    const extra = [l2, l3, l4, locality].filter(Boolean);
    return {
      line1: line1 || extra.shift() || '',
      line2: extra.join(', '),
      city: town || '',
      county: county || ''
    };
  }
  const filled = parts.filter(Boolean);
  return {
    line1: filled[0] || '',
    line2: filled.slice(1, -1).join(', '),
    city: filled.length > 1 ? filled[filled.length - 1] : '',
    county: ''
  };
}

export function addressLabel(fields) {
  return [fields.line1, fields.line2, fields.city].filter(Boolean).join(', ');
}

/** Loose UK postcode check — enough to stop typos, not a full validator. */
export function looksLikeUkPostcode(value) {
  return /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i.test(String(value || '').trim());
}

/** Accepts 07… mobiles, 01/02/03 landlines and +44 forms, ignoring spaces and dashes. */
export function looksLikeUkPhone(value) {
  const digits = String(value || '').replace(/[\s\-()]/g, '');
  return /^(\+44|0044|0)\d{9,10}$/.test(digits);
}
